
 <div class="cardGrid" [ngClass]="'cols-' + cols">

	<div *ngFor="let i of items" class="col-item">
		<div class="overviewStreamCard" style="background: none !important; box-shadow:none;">
			<ngx-skeleton-loader [theme]="itemTheme" appearance="circle"></ngx-skeleton-loader>
		</div>
	</div>

 </div>
